import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import Form from "../../shared/form/forms"
import UserEventApi from "../../services/api/UserEvent.api"
import { IRedux } from "../../services/types"
import { IUser } from "../../interfaces/user"
import { IForm } from "../../interfaces/form"
import FormApi from "../../services/api/Form.api"
import { nextStep } from "../../redux/inscription"

const FormStep = () => {
  const dispatch = useDispatch()

  const userId = useSelector((state: IRedux) => state.inscription.userId)
  const formId = useSelector((state: IRedux) => state.settings?.extended.formId)

  const [user, setUser] = useState<IUser | null>(null)
  const [form, setForm] = useState<IForm | null>(null)

  useEffect(() => {
    if (!userId || !formId) return
    Promise.all([
      new UserEventApi().getByUserId(userId).then(setUser),
      new FormApi().getById(formId).then(setForm)
    ])
  }, [formId, userId])

  if (!user) return null

  return <Form user={user} form={form} afterSave={() => dispatch(nextStep())} />
}

export default FormStep
